import {
	DELETE_FAQ_FAIL,
	DELETE_FAQ_START, DELETE_FAQ_SUCCESS,
	GENERATE_FAQ_FAIL,
	GENERATE_FAQ_START,
	GENERATE_FAQ_SUCCESS, SEARCH_FAQ_FAIL,
	SEARCH_FAQ_START, SEARCH_FAQ_SUCCESS, UPDATE_FAQ_FAIL, UPDATE_FAQ_START, UPDATE_FAQ_SUCCESS
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {DELETE_FAQ_URL, GENERATE_FAQ_URL, SEARCH_FAQ_URL, UPDATE_FAQ_URL} from "./utils/ApiUrls";
import {getConfig} from "./utils/ConfigUtils";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";

export function generateFaq(faq, dispatch) {
	dispatch({type: GENERATE_FAQ_START});
	axios
		.post(GENERATE_FAQ_URL, faq, getConfig())
		.then(() => dispatch({type: GENERATE_FAQ_SUCCESS}))
		.catch((error) => dispatch({type: GENERATE_FAQ_FAIL, error: getErrorMessage(error)}))
}

export function searchFaq(faqExample, dispatch) {
	dispatch({type: SEARCH_FAQ_START});
	axios
		.post(SEARCH_FAQ_URL, faqExample)
		.then((response) => dispatch({type: SEARCH_FAQ_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: SEARCH_FAQ_FAIL, error: getErrorMessage(error)}))
}

export function deleteFaq(faq, dispatch) {
	dispatch({type: DELETE_FAQ_START});
	axios
		.post(DELETE_FAQ_URL, faq, getConfig())
		.then(() => dispatch({type: DELETE_FAQ_SUCCESS}))
		.catch((error) => dispatch({type: DELETE_FAQ_FAIL, error: getErrorMessage(error)}))
}

export function updateFaq(faq, dispatch) {
	dispatch({type: UPDATE_FAQ_START});
	axios
		.post(UPDATE_FAQ_URL + faq.id, faq, getConfig())
		.then(() => dispatch({type: UPDATE_FAQ_SUCCESS}))
		.catch((error) => dispatch({type: UPDATE_FAQ_FAIL, error: getErrorMessage(error)}))
}
